import type { OrderAdminUser } from '@/models/OrderAdminUser';

/**
 * The roles whose holders are order administrators, as `role/users` is asked for them. The
 * API compares names lower-cased with spaces removed, so 'leadOrderAdministrator' matches the
 * stored 'Lead Order Administrator'.
 */
export const ORDER_ADMIN_ROLES = [
  'orderAdministrator',
  'leadOrderAdministrator',
  'financeControllerAndOrderAdmin',
];

/**
 * Offered on every order whatever its factory. An Order Administrator is offered only on the
 * factories linked to them; a Lead runs the whole team. The Finance Controller also runs orders
 * (Zendesk #10444) and the user form cannot link factories to her role, so she is offered on every
 * factory too.
 */
const EVERY_FACTORY_ROLES = ['leadorderadministrator', 'financecontrollerandorderadmin'];

const normalise = (role: string): string => role.replace(/\s+/g, '').toLowerCase();

export const isOfferedForEveryFactory = (admin: OrderAdminUser): boolean =>
  admin.role_names?.some((role) => EVERY_FACTORY_ROLES.includes(normalise(role))) ?? false;
